import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./auth";
import { CountersProvider } from "./counters";
import { registerServiceWorker } from "./push";
import "./theme.css";

registerServiceWorker();

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <CountersProvider>
          <App />
        </CountersProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
